import { render, staticRenderFns } from "./Academic-mgnt.vue?vue&type=template&id=4d07cfce&scoped=true&"
import script from "./Academic-mgnt.vue?vue&type=script&lang=js&"
export * from "./Academic-mgnt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d07cfce",
  null
  
)

export default component.exports